import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-progress-bar",
    templateUrl: "./progress-bar.component.html",
    styleUrls: ["./progress-bar.component.scss"],
    standalone: false
})
export class ProgressBarComponent implements OnInit {
  @Input() current: number;
  @Input() total: number;
  @Input() color: string;

  progress: number = 0;

  constructor() {}

  ngOnInit(): void {
    //this.current = Math.random() * this.total; //to quickly test
    if (this.total > 0) {
      this.progress = Math.floor((this.current / this.total) * 100);
    }
  }
}
